<div class="mt-2 flex justify-between items-center" [class.flex-wrap]="mobileWrap" [class.md:flex-nowrap]="mobileWrap">
  <div>
    <h1 class="profile-section-title flex items-center gap-2">
      {{ headerTitle | translate }}
      @if (showTourIcon) {
        <!-- TODO: consider help-book component -->
        <app-nicky-button variant="text" size="extra-small" (click)="onTour.emit()">
          <mat-icon svgIcon="help-book" id="bookIcon"></mat-icon>
        </app-nicky-button>
      } @else {
        <!-- empty element to make the layout consistent -->
        <span class="inline-block w-10 h-9"></span>
      }
    </h1>
    <h3 class="profile-section-subtitle">{{ subtitle | translate }}</h3>
  </div>

  @if (showHeaderButton) {
    <app-nicky-button
      [fullWidth]="mobileWrap"
      [class.w-full]="mobileWrap"
      [class.md:w-fit]="mobileWrap"
      [class.mt-4]="mobileWrap"
      [class.md:mt-0]="mobileWrap"
      id="settings-header-save"
      [variant]="ButtonVariant"
      [iconLeft]="buttonIcon"
      (click)="onSave.emit()"
      [disabled]="isHeaderButtonDisabled"
    >
      {{ buttonText }}
    </app-nicky-button>
  }
</div>

<hr class="mt-2 mb-4 border-gray-200" />
